import { Menu, ActionIcon } from '@mantine/core';
import { IconTrash, IconFileDescription, IconCheck, IconX, IconDots, IconPackage, IconPackageOff, IconPackgeExport } from '@tabler/icons';
import { FC, useContext } from 'react';
import { i18n } from '@lingui/core';
import { Planning } from '../../../../Types/ResourceT';
import ResourcePlanningS from '../../../../Service/restapi/resourcePlanningS';
import { ToastS } from '../../../../Service/ToastS';
import { WindowContext } from '../../../../Service/Context/WindowContext';
import { openPlanningDrawerModal } from '../../PlanningDrawerModal';

interface Props {
  planning: Planning;
  refresh: () => unknown;
  removePlanning: () => void;
}

const PlanningActions: FC<Props> = ({ planning, refresh, removePlanning }) => {
  const {
    id: planningId,
    warehousePlanning,
    packedAt,
    resource: { name },
  } = planning;
  const { xs } = useContext(WindowContext);

  const reserve = async () => {
    const resJSON = await ResourcePlanningS.confirmResourcePlanning(planningId);
    if (resJSON) {
      refresh();
    }
  };

  const cancelReservation = async () => {
    if (warehousePlanning) {
      const cancelled = await ResourcePlanningS.deleteWarehousePlanning(warehousePlanning.id);
      if (cancelled) {
        refresh();
      }
    }
  };

  const updatePackedAt = async (packedAtValue: Date | null) => {
    const resJSON = await ResourcePlanningS.updatePlanning(planningId, { packedAt: packedAtValue });
    if (resJSON) {
      ToastS.info(
        `planning-packed-${planningId}`,
        packedAtValue ? `Ressource ${name} wurde gepackt.` : `Ressource ${name} wurde entpackt.`,
      );
      refresh();
    }
  };

  return (
    <Menu shadow="md" width={150} position="bottom-end" transition="scale-y">
      <Menu.Target>
        <ActionIcon>
          <IconDots />
        </ActionIcon>
      </Menu.Target>
      <Menu.Dropdown>
        {xs && (
          <Menu.Item
            icon={<IconFileDescription size={16} />}
            onClick={() => openPlanningDrawerModal({ planning, refresh, defaultPlannings: false })}
          >
            Einzelheiten
          </Menu.Item>
        )}
        {!warehousePlanning && (
          <Menu.Item icon={<IconCheck size={16} />} onClick={reserve}>
            Bestätigen
          </Menu.Item>
        )}
        {warehousePlanning && (
          <Menu.Item icon={<IconX size={16} />} onClick={cancelReservation}>
            Entfernen
          </Menu.Item>
        )}
        {!packedAt && (
          <Menu.Item icon={<IconPackgeExport size={16} />} onClick={() => updatePackedAt(new Date())}>
            Packen
          </Menu.Item>
        )}
        {packedAt && (
          <Menu.Item icon={<IconPackageOff size={16} />} onClick={() => updatePackedAt(null)}>
            Entpacken
          </Menu.Item>
        )}
        <Menu.Item color="red" icon={<IconTrash size={16} />} onClick={removePlanning}>
          {i18n._('actions.delete')}
        </Menu.Item>
      </Menu.Dropdown>
    </Menu>
  );
};

export default PlanningActions;
